import { render } from "./Empfehlung.vue?vue&type=template&id=7af0a54a"
import script from "./Empfehlung.vue?vue&type=script&lang=js"
export * from "./Empfehlung.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__